import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Button, TextField } from '@material-ui/core';
import { get } from 'lodash';

import { getSettings,setSettings,navigateTo } from '../../redux/actions'




import Loading from '../common/loading';
import BackToPage from '../common/back-to-page';
import { colors,patientGoalBaseStyles } from '../../theme/style';
import AdminLayout from '../user/admin/AdminLayout';
import { urls } from '../../utils/Objects';
import Alerts from '../common/Alerts';



class PatientSettings extends Component {
  state = {
    new: false,
    serial_number: '',
  };

  componentDidMount()
  {
    this.props.getSettings(this.props.selectedPatient.user_id)
  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  };


  handleSave = () => {
    const patientId = this.props.selectedPatient.user_id
    this.props.setSettings(patientId,{"serial_number":this.state.serial_number})
  };


  render() {
    let name_display=this.props.selectedPatient.first_name;
    let birth_date_display=this.props.selectedPatient.birth_date;
   
    return (<AdminLayout {...this.props}>
    <Alerts />
      <section style={patientGoalBaseStyles.container}>
        <div navstyle={patientGoalBaseStyles.navstyle}>
          <BackToPage link={urls.patients} text="Patient List"/>
        </div>

       <div style={patientGoalBaseStyles.patientName}>
          {name_display}
        </div>
        <div style={patientGoalBaseStyles.birthDate}>
          Birth Date: &nbsp;
          {moment(birth_date_display).format('MMM D,YYYY')}
        </div>

         

        <div style={patientGoalBaseStyles.compliance}>
          <section style={patientGoalBaseStyles.margin}>
          Serial Number<TextField
              name="serial_number"
              placeholder="Device Serial Number"
              style={patientGoalBaseStyles.textField}
              value={this.state.serial_number}
              onChange={this.handleChange}
              type="number"
            />
            <br/>
          </section>
          <section style={patientGoalBaseStyles.btns}>
            <Button
              color="primary"
              variant="contained"
              style={patientGoalBaseStyles.saveBtn}
              // disabled={!this.state.compliance_hours || cobbSettings.editCobbSettingsPending || cobbSettings.addCobbSettingsPending}
              disabled={!this.state.serial_number}
              onClick={this.handleSave}
            >
              {this.state.new ? 'Save' : 'Update'}
            </Button>
          </section>

        </div>
      </section>
    </AdminLayout>);
    }


  }





  const mapStateToProps = (state,ownProps) => {
    const selectedPatient = ownProps.location.state;
    return (
        {
            login: state.login,
            user: state.user,
            selectedPatient:selectedPatient
        }
    )
}


const mapDispatchToProps = {
  
    navigateTo,
    getSettings,
    setSettings
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientSettings)